import { createContext, useContext } from 'react';
import { gate } from 'hub-http/gates';
import { jsx as _jsx } from "react/jsx-runtime";
const AuthInfoContext = /*#__PURE__*/createContext(undefined);
export const AuthInfoProvider = ({
  authInfo,
  children
}) => {
  return /*#__PURE__*/_jsx(AuthInfoContext.Provider, {
    value: authInfo,
    children: children
  });
};
export function useAuthInfoProvider() {
  const context = useContext(AuthInfoContext);
  if (context === undefined) {
    throw new Error('useAuthInfoProvider must be used within a AuthInfoProvider');
  }
  // FIXME: Remove this once all clients stop using it
  const getIsUngatedToUseResolvedStateProperty = () => {
    return context.userInfo.gates.includes(gate('CMP:UseResolvedStateProperty'));
  };
  const getIsUngatedForCMPTrellisMigration = () => context.userInfo.gates.includes(gate('CMP:TrellisSelectMigration'));
  return {
    userInfo: context.userInfo,
    portalScopes: context.portalScopes || [],
    getIsUngatedToUseResolvedStateProperty,
    getIsUngatedForCMPTrellisMigration
  };
}